import store from "../../../store";
import shipday_export from "./shipday_export.vue";

window.shopify_export =  new Vue({
    store,
    el: 'div#shipday_export',

    name : "shipday_export",
    data () {
        return {

        }
    },
    created () {

    },
    components : {
        shipday_export,
    }
});
